/*
 * @Description:
 * @Date: 2021-08-19 14:32:29
 */
export const canChoose = info => {
  // projectStatus //项目状态  0 乙方待编辑  1  乙方编辑完成   2 甲方待确认   3 甲方编辑完成(甲方已确认)
  // auditStatus //审核状态  0 未提交审核  1 审核中  2 审核未通过  3  审核通过
  return info.projectStatus == 2;
};
